module.exports = __webpack_public_path__ + "img/Typescript.87da2928.svg";